import React from 'react'
import PropTypes from 'prop-types'
import Slider from 'react-slick'

import './fullslider.scss'

export default class FullSlider extends React.PureComponent {
  static propTypes = {
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
    active: PropTypes.number.isRequired,
    onSelectSliderItem: PropTypes.func.isRequired,
    isDestination: PropTypes.bool.isRequired,
  }

  componentDidUpdate(prevProps) {
    const { active } = prevProps
    if (active !== this.props.active) {
      this.slider.slickGoTo(this.props.active - 1)
    }
  }

  render() {
    const {
      results, onSelectSliderItem, isDestination, active, itemComponent
    } = this.props

    const sliderSettings = {
      cssEase: 'slider variable-width',
      infinite: false,
      centerMode: false,
      variableWidth: true,
      arrows: false,
      initialSlide: active - 1,
      speed: 500,
      focusOnSelect: true,
      beforeChange: function (slide, nextSlide) {
        const nextSlideData = results[nextSlide]
        if (nextSlideData) {
          onSelectSliderItem(nextSlideData?.id)
        }
      },
    }

    const SlideItem = itemComponent;

    return (
      <div className="map-slider">
        <div className="slide-wrapper">
          <Slider {...sliderSettings} ref={(slider) => { this.slider = slider }}>
            {results.map((item) => (
              <SlideItem
                isDestination={isDestination}
                key={item.id}
                item={item}
              />
            ))}
          </Slider>
        </div>
      </div>
    )
  }
}
